import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";
import { KreFormAntService } from "../tools/service";

@Component({
  selector: "krefield-checkbox",
  template: `
    <ng-container *ngIf="formStatus !== 0; else other">
      <div class="control-design">
        <label nz-checkbox nzDisabled="true"></label>
      </div>
    </ng-container>

    <ng-template #other>
      <ng-container *ngIf="editor === true">
        <label
          nz-checkbox
          [formControl]="formControl"
          [kreFormAttributes]="field"
          [class.is-invalid]="showError"
        ></label>
        <!-- <div class="tips">
          <i
            class="icon-bangzhu"
            [nzTooltipTitle]="tips"
            nzTooltipPlacement="top"
            nz-tooltip
            *ngIf="tips != ''"
          ></i>
        </div> -->
      </ng-container>

      <div class="fieldtext" *ngIf="editor === false">{{ text }}</div>
    </ng-template>
  `,
})
export class KreFormFieldCheckbox extends FieldType {}
